export default [
  {
    path: '/core',
    redirect: { name: 'userPreferences' }
  },
  {
    path: '/trackntrace',
    redirect: '/trackntrace/dashboards/supplychainoverview'
  },
  {
    path: '/compass/supplychain',
    redirect: '/trackntrace/dashboards/supplychainoverview'
  },
  {
    path: '/kcengine/ati',
    redirect: '/core/configuration/atis'
  },
  {
    path: '/kcengine/ati-group/',
    redirect: '/core/configuration/atigroups'
  },
  {
    path: '/configuration/products',
    redirect: '/core/configuration/products'
  },
  {
    path: '/compass/pickinglists',
    redirect: '/trackntrace/shipments'
  },
  {
    path: '/kcengine/order',
    redirect: '/core/orders'
  },
  {
    path: '/security/users',
    redirect: '/core/management/users'
  },
  {
    path: '/orders',
    redirect: '/kcengine/order'
  },
  {
    path: '/kcengine/orders',
    redirect: '/kcengine/order'
  },
  {
    path: '/security/login',
    redirect: '/login'
  },
  {
    path: '/compass/pickinglists/:id/edit',
    redirect: '/trackntrace/shipment/:id/edit'
  },
  {
    path: '/kcengine/entry-channel/:id/edit',
    redirect: '/core/validation/entrychannel/:id/edit'
  },
  {
    path: '/kcengine/entry-channels',
    redirect: '/core/validation/entrychannels'
  },
  {
    path: '/kcengine/codeconfigs',
    redirect: '/core/configuration/codeconfigurations'
  },
  {
    path: '/kcengine/order/:orderId/section/:sectionId/edit',
    redirect: '/core/orders/order/:orderId/section/:sectionId/edit'
  },
  {
    path: '/kcengine/order/:orderId/section/new',
    redirect: '/core/orders/order/:orderId/section/new'
  },
  {
    path: '/kcengine/order/:orderId/section/:sectionId/messages',
    redirect: '/core/orders/order/:orderId/section/:sectionId/messages'
  },
  {
    path: '/kcengine/product-metadata-schemas',
    redirect: '/core/configuration/product-metadata-schemas'
  },
  {
    path: '/kcengine/products/:id',
    redirect: '/core/configuration/product/:id'
  },
  {
    path: '/kcengine/order/:id',
    redirect: '/core/orders/order/:id'
  },
  {
    path: '/kcengine/order/:id/edit',
    redirect: '/core/orders/order/:id/edit'
  },
  {
    path: '/kcengine/order/:id/sections',
    redirect: '/core/orders/order/:id/sections'
  },
  {
    path: '/compass/recalls',
    redirect: '/trackntrace/configuration/recalls'
  },
  {
    path: '/compass/recalls/:id',
    redirect: '/trackntrace/configuration/recall/:id'
  },
  {
    path: '/kcengine/order/:orderId/section/:sectionId',
    redirect: 'core/orders/order/:orderId/section/:sectionId/view'
  },
  {
    path: '/compass/trace/:code',
    redirect: '/trackntrace/dashboards/trace/:code'
  },
  {
    path: '/kcengine/order/:id/metadata',
    redirect: '/core/orders/order/:id/metadata'
  },
  {
    path: '/kcengine/order/:orderId/section/:sectionId/metadata',
    redirect: '/core/orders/order/:orderId/section/:sectionId/metadata'
  },
  {
    path: '/kcengine/products/product-metadata/:productId',
    redirect: '/core/configuration/product/:productId/metadata'
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/redirects.js